module.exports = __webpack_public_path__ + "dislike.437a54c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/articles/dislike.png
// module id = 3050
// module chunks = 0